module.exports = __webpack_public_path__ + "76d4147694fd93f6b295691c4a781e31.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/letters/1.png
// module id = 3613
// module chunks = 0